import api from "@/services/api.service";

/** Client activity: one request returns the merged communications + activity timeline. */
export const clientActivityModule = {
    namespaced: true,
    actions: {
        getActivity(actions, request) {
            return new Promise(function (resolve, reject) {
                api.sendRequest('clientActivity/get', null, request).then(
                    (ans) => {
                        resolve(ans);
                    }, (error) => {
                        actions.dispatch('notifications/error',
                            {
                                title: 'Client activity',
                                message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                            },
                            {root: true});
                        reject(error)
                    })
            })
        },
    }
}
